/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 06 2024
 **/

import { create } from "zustand";

import { OwnerInfo } from "../types/types";

type NetworkWhiteboardState = {
	ownerInfo: OwnerInfo;
};

type NetworkWhiteboardAction = {
	setOwnerInfo: (ownerInfo: OwnerInfo) => void;
};

type NetworkWhiteboardStoreProps = NetworkWhiteboardState & NetworkWhiteboardAction;

const DefaultNetworkWhiteboardState: NetworkWhiteboardState = {
	ownerInfo: null
};

const useNetworkWhiteboardStore = create<NetworkWhiteboardStoreProps>((set) => ({
	...DefaultNetworkWhiteboardState,
	setOwnerInfo: (ownerInfo) => set(() => ({ ownerInfo }))
}));

export default useNetworkWhiteboardStore;
